<template>
  <main class="auth-landing">
    <div class="auth-landing__frame">
      <header class="auth-landing__brand" aria-label="WELL COME FIT App">
        <img class="auth-brand-logo" :src="brandLogo" alt="WELL COME FIT" width="1200" height="931" />
        <span class="auth-app-label">WELL COME FIT App</span>
      </header>

      <div class="auth-landing__content">
        <section class="auth-landing__copy">
          <span class="auth-eyebrow">Dein Training. Eine App.</span>
          <h1>Mehr bewegen.<br /><span>Mehr erreichen.</span></h1>
          <p class="auth-landing__lead">Kurse entdecken, Training planen und mit deinem Studio verbunden bleiben – alles an einem Ort.</p>

          <ul class="auth-feature-list" aria-label="App-Vorteile">
            <li><v-icon aria-hidden="true">mdi-calendar-check-outline</v-icon>Kurse im Blick</li>
            <li><v-icon aria-hidden="true">mdi-dumbbell</v-icon>Training dabei</li>
            <li><v-icon aria-hidden="true">mdi-account-group-outline</v-icon>Studio verbunden</li>
          </ul>
        </section>

        <section class="auth-entry-card" aria-labelledby="auth-entry-title">
          <span class="auth-entry-card__kicker">Willkommen</span>
          <h2 id="auth-entry-title">Schön, dass du da bist.</h2>
          <p>Melde dich an oder erstelle in wenigen Schritten deinen persönlichen WELL COME FIT Account.</p>

          <div class="auth-entry-card__actions">
            <v-btn depressed block class="auth-primary-button" @click="setLoginFormActive">
              Anmelden
              <v-icon right aria-hidden="true">mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn depressed block class="auth-secondary-button" @click="setRegisterFormActive">Account erstellen</v-btn>
          </div>

          <div class="auth-entry-card__note">
            <v-icon aria-hidden="true">mdi-shield-check-outline</v-icon>
            <span>Deine Daten bleiben sicher bei WELL COME FIT.</span>
          </div>
        </section>
      </div>
    </div>

    <login
      :active="loginActive"
      :dialog-origin="dialogOrigin"
      show-mode-switch
      @close="loginActive = false"
      @show-register="showRegisterFromLogin"></login>
    <register
      :active="registerActive"
      :dialog-origin="dialogOrigin"
      show-mode-switch
      @close="registerActive = false"
      @show-login="showLoginFromRegister"></register>
  </main>
</template>

<script>
import "./authTheme.scss"
import { brandLogo } from "@/constants/brandAssets"
import login from "./login.vue"
import register from "./register.vue"

export default {
  components: {
    login,
    register,
  },
  data() {
    return {
      brandLogo,
      dialogOrigin: "50% 50%",
      loginActive: false,
      registerActive: false,
    }
  },
  created() {
    if (window.flutter_inappwebview) window.flutter_inappwebview.callHandler("showAppTrackingTransparency")
    if (localStorage.getItem("msg_open_roody")) {
      this.hide_temp = true
    }
    this.syncDialogWithRoute(this.$route.name)
  },
  watch: {
    "$route.name"(routeName) {
      this.syncDialogWithRoute(routeName)
    },
  },
  methods: {
    setDialogOrigin(event) {
      const target = event && (event.currentTarget || event.target)
      if (!target || typeof target.getBoundingClientRect !== "function") {
        this.dialogOrigin = "50% 50%"
        return
      }

      const { top, left, width, height } = target.getBoundingClientRect()
      this.dialogOrigin = `${Math.round(left + width / 2)}px ${Math.round(top + height / 2)}px`
    },
    setRegisterFormActive(event) {
      this.setDialogOrigin(event)
      this.loginActive = false
      this.registerActive = true
    },
    setLoginFormActive(event) {
      this.setDialogOrigin(event)
      this.registerActive = false
      this.loginActive = true
    },
    showRegisterFromLogin() {
      this.loginActive = false
      this.$nextTick(() => {
        this.registerActive = true
      })
    },
    showLoginFromRegister() {
      this.registerActive = false
      this.$nextTick(() => {
        this.loginActive = true
      })
    },
    syncDialogWithRoute(routeName) {
      if (routeName === "Forgot") {
        this.registerActive = false
        this.loginActive = true
      } else if (routeName === "Registrieren") {
        this.loginActive = false
        this.registerActive = true
      } else if (routeName === "login") {
        this.loginActive = false
        this.registerActive = false
      }
    },
    saveMsg() {
      localStorage.setItem("msg_open_roody", true)
      this.hide_temp = true
    },
    redirectToBewertung() {
      return Boolean(this.$route.query.redirect)
    },
    redirectToAffiliate() {
      return Boolean(this.$route.query.forward)
    },
  },
  computed: {
    forgottenLink() {
      return this.$route.name === "Forgot"
    },
  },
}
</script>
